import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39963df9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chatBoxContainer",
  class: "p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5"
}
const _hoisted_2 = { class: "text-center fw-bold fs-6 my-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "me-lg-3 mb-4 me-0 mb-lg-0 w-100" }
const _hoisted_8 = {
  key: 1,
  class: "invalid-error"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mb-2 d-flex justify-content-center" }

import { computed, ComputedRef, nextTick, onMounted, onUnmounted, ref, watch, watchEffect } from 'vue'
import Button from '@/components/button/index.vue'
import MessageItemTalkroom from '@/views/user/conversations/components/MessageItemTalkroom.vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ChatModal from '@/views/user/conversations/components/ChatModal.vue'
import Heading from '@/views/user/groups/components/Heading.vue'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import TargetTag from '@/components/target-tag/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { useStore } from 'vuex'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { ACCOUNT_STORE, CHAT_STORE, GROUPS_STORE, ROOT_STORE } from '@/store/constants'
import { ChatStateTypes } from '@/store/modules/chat'

import VirtualList from 'vue3-virtual-scroll-list'
import { useWebSocket } from '@/use/useWebsocket'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { checkLimitMention, customMaxLengthTextMention, customMinLength } from '@/utils'
import MentionTextarea from '@/components/mention-textarea/index.vue'
import { HANDLE_USERS_MENTION, LIST_USER_NAME } from '@/constants/common'
import { useChat } from '@/composables/chat'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const virtual_list = ref()
const { connection, reconnect } = useWebSocket('talkChannel', {
  onConnected: () => {
    // Only re-fetch data if the page has finished initializing its initial data
    // Ensure the API is re-fetched in both cases: remaining on the tab and background reconnection
    if (getData.value) {
      fetchTalkRoomData()
    }
  },
})

const talk_room_data = computed<ComputedRef<Pick<ChatStateTypes, 'talk_room'>>>(() => store.getters[CHAT_STORE.GETTERS.TALK_ROOM])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const loadingChat = computed(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])
const mentionReady = ref(null)
const users = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_MENTION_USER])
const listUserShow = computed(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])
const mentionUsers = computed(() => LIST_USER_NAME(users.value?.data, users.value))
const loading = ref<boolean>(false)
const mentionComponent = ref<{ clear: () => void } | null>(null)
const errorOccurred = ref(false)
const reconnecting = ref(false)
const { setTimeoutScroll } = useChat()

const rules = computed(() => {
  return {
    content: {
      // required,
      maxLength: (value: string) => customMaxLengthTextMention(value, 500, formData.value.mention_user_ids, mentionUsers.value, formData.value.rawContent),
      // minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
      limitMention: (value: string) => checkLimitMention(value, formData.value.mention_user_ids),
      errorOccurred: () => !errorOccurred.value,
    },
  }
})

const formData = ref({
  content: '',
  mention_user_ids: [],
  rawContent: '',
})

const back = (): void => {
  router.push(route.path.split('/').slice(0, -1).join('/'))
}
const dataLoadMore = ref()
watchEffect(() => {
  dataLoadMore.value = talk_room_data.value?.talk_room?.chat?.filter((e) => e.published)
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

const v1$ = useVuelidate(rules, formData)
const sendMessage = ref(false)
const onSubmit = async (): Promise<void> => {
  v1$.value.$touch()
  if (errorOccurred.value) return

  isCheckedNGKeyContent.value = false
  await checkNGContent()
  while (!isCheckedNGKeyContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v1$.value.$errors.some((e) => e.$property === 'content')) return
  if (ngKeyContent.value) return

  store.dispatch(CHAT_STORE.ACTIONS.SEND_MESSAGE_TALK_ROOM, {
    talkroom_id: route.params?.talkroom_id,
    content: {
      content: formData.value.content,
      mention_user_ids: formData.value.mention_user_ids,
    },
  })
  sendMessage.value = true
  v1$.value.$reset()
  mentionComponent.value?.clear()
  Object.assign(formData.value, {
    content: '',
    mention_user_ids: [],
  })
}

const changeContent = async (content: any) => {
  v1$.value.content.$model = content.content
  formData.value.mention_user_ids = content.mentionedUserIds
  formData.value.rawContent = content.rawContent
  await checkNGContent()
}

const checkErrorOccurred = (error: boolean) => {
  errorOccurred.value = error
}

const getData = ref<boolean>(false)
const idComment = ref(null)

const fetchTalkRoomData = async () => {
  if (route.params?.talkroom_id) {
    await store.dispatch(CHAT_STORE.ACTIONS.GET_TALK_ROOM, { id: route.params?.talkroom_id, params: { page: 1, change: true, target_content_id: idComment.value } })
  }
}

const handleReconnect = async () => {
  // Skip if the tab is inactive or there is no network connection.
  if (document.visibilityState !== 'visible' || !navigator.onLine) return

  // Skip if the page has not finished loading data for the first time.
  if (!getData.value) return

  // Skip if switching tabs normally while the socket connection remains active (OPEN)
  if (connection.value?.readyState === WebSocket.OPEN) return

  // Skip if currently reconnecting
  if (reconnecting.value) return
  reconnecting.value = true

  try {
    // Only handles the task of re-activating the socket
    // The fetchTalkRoomData function will be AUTOMATICALLY called by the onConnected callback as soon as the socket connects!
    await reconnect()
  } catch (error) {
    console.error('Failed to reconnect talk room', error)
  } finally {
    reconnecting.value = false
  }
}

const addReconnectListeners = () => {
  // Reconnect after page restoration from bfcache (especially Safari/iOS)
  window.addEventListener('pageshow', handleReconnect)
  // Reconnect and sync data when user switches back to this tab
  document.addEventListener('visibilitychange', handleReconnect)
}

const removeReconnectListeners = () => {
  window.removeEventListener('pageshow', handleReconnect)
  document.removeEventListener('visibilitychange', handleReconnect)
}

onMounted(async () => {
  addReconnectListeners()
  idComment.value = route.query?.target_content_id
  if (route.params?.talkroom_id) {
    loading.value = true
    try {
      await fetchTalkRoomData()
      await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
      await getListUserMention()
      getData.value = true
    } finally {
      loading.value = false
    }
  }
})

onUnmounted(() => {
  removeReconnectListeners()
})

const getListUserMention = async () => {
  mentionReady.value = false
  await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_MENTION_USER, {
    group_id: route.params?.group_id,
    talk_room_id: route.params?.talkroom_id,
  })
  mentionReady.value = true
}

watch(
  () => message.value,
  () => {
    if (message.value?.talkroom_id === route.params?.talkroom_id) {
      if (message.value?.type === 'create') {
        store.dispatch(CHAT_STORE.ACTIONS.RECEIVE_MESSAGE_TALK_ROOM, message.value)
      }
      if (message.value?.type === 'delete') {
        store.dispatch(CHAT_STORE.ACTIONS.REMOVE_MESSAGE_TALK_ROOM_WS, message.value.id)
      }
      if (message.value?.type === 'update') {
        store.dispatch(CHAT_STORE.ACTIONS.UPDATE_STATUS_MESSAGE_SOCKET, { id: message.value.id, published: message.value.published, data: message.value })
      }
    }
  },
  {
    deep: true,
  }
)

const stopScroll = ref(false)
watch(
  () => talk_room_data?.value.talk_room.chat,
  async () => {
    await nextTick()
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      const scroller = document.querySelector('.scroller')
      if (scroller) scrollMessage(scroller, 9999999999)
    } else {
      virtual_list.value.scrollTop = 8000
      const scroller = document.querySelector('.scroller')
      if (scroller) scrollMessage(scroller, sendMessage.value ? 9999999999 : 8000)
    }
  },
  {
    deep: true,
  }
)

const scrollMessage = async (scroller: Element, scrollTop: number) => {
  if (idComment.value && !stopScroll.value) {
    const element = document.getElementById(idComment.value) as HTMLElement | null
    if (element) {
      while (!mentionReady.value) {
        await new Promise((resolve) => setTimeout(resolve, 500))
      }
      stopScroll.value = true
      const elementPosition = element.offsetTop - scroller.offsetTop
      scroller.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })

      setTimeoutScroll(element)
    }
  } else {
    sendMessage.value = false
    scroller.scrollTop = scrollTop
  }
}

watchEffect(() => {
  if (!Object.keys(talk_room_data.value?.talk_room?.header).length && getData.value) {
    router.replace(`/${route.path.split('/')[1]}/communities/${route.params?.id}/groups/${route.params?.group_id}/talk_rooms`)
  }
})

onMounted(() => {
  virtual_list.value = document.querySelector('.scroller')
})

const isCheckedNGKeyContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v1$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGKeyContent.value = true
}, 200)

onBeforeRouteLeave(() => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Heading),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(talk_room_data).talk_room?.header.talk_room_name), 1),
      _createVNode(TargetTag, {
        data: _unref(talk_room_data).talk_room?.header.talk_room_information,
        className: 'mb-4 fs-8 border-bottom pb-4'
      }, null, 8, ["data"]),
      (_unref(loadingChat))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode(_unref(VirtualList), {
        class: "scroller",
        ref: (_value, _refs) => {
          _refs['virtual_list'] = _value
          virtual_list.value = _value
        },
        style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
        "estimate-size": 80,
        keeps: 1000,
        start: 14,
        "data-key": 'id',
        offset: 300,
        "data-sources": dataLoadMore.value,
        "data-component": MessageItemTalkroom,
        "extra-props": { source: _unref(talk_room_data).talk_room?.chat, users: _unref(listUserShow), id_comment: idComment.value }
      }, null, 8, ["data-sources", "extra-props"]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        action: "",
        class: _normalizeClass(['bg-gray p-2 d-flex form-chat', !_unref(isMobile) ? 'align-items-center' : ''])
      }, [
        _createElementVNode("div", _hoisted_7, [
          (!loading.value)
            ? (_openBlock(), _createBlock(MentionTextarea, {
                key: 0,
                users: _unref(HANDLE_USERS_MENTION)(_unref(mentionUsers), _unref(listUserShow)),
                "title-mention": _unref(translate)('titleMentionTalkRoom'),
                "class-name": ['form-control p-2', ngKeyContent.value || _unref(v1$).content.$error ? 'is-invalid' : ''],
                onContent: changeContent,
                onGetListUserMention: getListUserMention,
                onCheckErrorOccurred: checkErrorOccurred,
                ref: (_value, _refs) => {
                  _refs['mentionComponent'] = _value
                  mentionComponent.value = _value
                }
              }, null, 8, ["users", "title-mention", "class-name"]))
            : _createCommentVNode("", true),
          (ngKeyContent.value && !_unref(v1$).content.$error && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createBlock(InputErrorMessage, {
                key: 2,
                title: _unref(translate)('chatContent'),
                params: [1, 500],
                validator: _unref(v1$).content.$errors[0]?.$validator
              }, null, 8, ["title", "validator"]))
            : _createCommentVNode("", true)
        ]),
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              title: _unref(translate)('SO65send'),
              type: 'secondary',
              onClick: onSubmit,
              disabled: !formData.value.content.trim()
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "button-mobile",
              htmlType: 'submit',
              disabled: ngKeyContent.value || !formData.value.content.trim()
            }, _toDisplayString(_unref(translate)('SO65send')), 9, _hoisted_9))
          : _createCommentVNode("", true)
      ], 42, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        className: "mb-0 mb-lg-3",
        onClick: back
      }, null, 8, ["title"])
    ]),
    _createVNode(ChatModal),
    _createVNode(DeleteChatModal, { isTalkRoom: true }),
    _createVNode(DeleteChatSuccessModal)
  ], 64))
}
}

})